var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_77323",
    "data-name": "Group 77323",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23760",
    "data-name": "Rectangle 23760",
    width: 14,
    height: 14,
    rx: 2,
    transform: "translate(0 2)",
    fill: "#0072c6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_77169",
    "data-name": "Group 77169",
    transform: "translate(4 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61774",
    "data-name": "Path 61774",
    d: "M2.246,3.97.03,1.754a.1.1,0,0,1,0-.144l.119-.119a.1.1,0,0,1,.144,0L2.318,3.516,5.8.03a.1.1,0,0,1,.144,0l.119.119a.1.1,0,0,1,0,.144L2.39,3.97A.1.1,0,0,1,2.246,3.97Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckbox);
export default __webpack_public_path__ + "static/media/Checked_Checkbox.0b4b5da807ce5077d4771e04dab84a6d.svg";
export { ForwardRef as ReactComponent };